import { useOutletContext } from 'react-router-dom';
import SeriesDisplay from '../../../../components/series-display/SeriesDisplay';

export default function FriendSeriesDisplay() {
  const context = useOutletContext();
  const { viewingUserID } = context || {};
  return <SeriesDisplay viewingUserID={viewingUserID} />;
}

